import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstace from "../../api/axiosInstance";

export const fetchDataUsers = createAsyncThunk(
  "api/fetchDataUsers",
  async ({ page = 1, limit = 8, searchQuery = "" }) => {
    try {
      const response = await axiosInstace.get("/auth/findAll", {
        params: {
          page,
          limit,
          value: searchQuery,
        },
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const activateGuestFromAdmin = createAsyncThunk(
  "activateGuestFromUser",
  async (data) => {
    try {
      const response = await axiosInstace.post(
        "/payments/activeGuestFromAdmin",
        data
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const updateDataUsers = createAsyncThunk(
  "api/updateDataUsers",
  async ({ id, updatedData }) => {
    try {
      const response = await axiosInstace.post(
        `/auth/updateUser/${id}`,
        updatedData
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const deleteDataUsers = createAsyncThunk(
  "auth/deleteDataUsers",
  async (itemId, thunkAPI) => {
    try {
      await axiosInstace.delete(`/auth/deleteGuestUser/${itemId}`);
      return itemId;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (credentials) => {
    try {
      const response = await axiosInstace.post("/auth/login", credentials);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const getActiveCategoryUserId = createAsyncThunk(
  "getActiveCategory",
  async (userId) => {
    try {
      const response = await axiosInstace.get(
        `/payments/getUserActiveCategory/${userId}`
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
export const logoutUser = createAsyncThunk("auth/logout", async () => {
  localStorage.removeItem("userToken");
  localStorage.removeItem("isAuthenticated");
});

export const resetUserData = createAsyncThunk(
  "user/resetUserData",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstace.delete(`/user/resetUserData`, {
        params: {
          user_id: id,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

export const getUserById = createAsyncThunk("user/getUserById", async (id) => {
  try {
    const response = await axiosInstace.get(`/user/getUserById/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message);
  }
});

export const removeDriveSchoolFromUser = createAsyncThunk(
  "users/removeDriveSchoolFromUser",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await axiosInstace.put(
        `/user/removeSchoolFromUser/${userId}`
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const initialState = {
  loading: false,
  user: null,
  error: null,
  success: false,
  data: [],
  userData: [],
  errorUserData: null,
  loadingUserData: false,
  currentPage: 1,
  totalPages: 1,
  totalCount: 0,
  activateGuestUser: [],
  laodingActivateGuestUser: false,
  errorActivateGuestUser: null,
  activeCategory: [],
  loadingActiveCategory: false,
  errorActiveCategory: null,
  loadingResetUser: false,
  resetUserResult: null,
  errorResetUser: null,
  deleteLoading: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getActiveCategoryUserId.pending, (state) => {
        state.loadingActiveCategory = true;
        state.errorActiveCategory = null;
      })
      .addCase(getActiveCategoryUserId.fulfilled, (state, action) => {
        state.activeCategory = action.payload;
        state.loadingActiveCategory = false;
      })
      .addCase(getActiveCategoryUserId.rejected, (state, action) => {
        state.loadingActiveCategory = false;
        state.errorActivateGuestUser = action.error.message;
      })
      .addCase(activateGuestFromAdmin.fulfilled, (state, action) => {
        state.laodingActivateGuestUser = false;
        state.activateGuestUser = action.payload;
      })
      .addCase(activateGuestFromAdmin.pending, (state) => {
        state.laodingActivateGuestUser = true;
        state.errorActivateGuestUser = null;
      })
      .addCase(activateGuestFromAdmin.rejected, (state, action) => {
        state.laodingActivateGuestUser = false;
        state.errorActivateGuestUser = action.error.message;
      })
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.error = null;
        state.success = true;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.user = null;
        state.error = action.error.message;
        state.success = false;
      })
      .addCase(logoutUser, (state) => {
        state.user = null;
        state.token = null;
        localStorage.removeItem("isAuthenticated");
      })
      .addCase(fetchDataUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDataUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.totalPages = action.payload.totalPages;
        state.totalCount = action.payload.totalCount;
      })
      .addCase(fetchDataUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(updateDataUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDataUsers.fulfilled, (state, action) => {
        state.loading = false;
      })

      .addCase(updateDataUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(deleteDataUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteDataUsers.fulfilled, (state, action) => {
        const deletedItemId = action.payload;
        if (Array.isArray(state.data)) {
          state.data = state.data.filter((item) => item.id !== deletedItemId);
        }
        state.loading = false;
      })
      .addCase(deleteDataUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(resetUserData.pending, (state) => {
        state.loadingResetUser = true;
        state.errorResetUser = null;
      })
      .addCase(resetUserData.fulfilled, (state, action) => {
        state.loadingResetUser = false;
        state.resetUserResult = action.payload;
      })
      .addCase(resetUserData.rejected, (state, action) => {
        state.loadingResetUser = false;
        state.errorResetUser = action.payload;
      })
      .addCase(getUserById.pending, (state) => {
        state.loadingUserData = true;
        state.errorUserData = null;
      })
      .addCase(getUserById.fulfilled, (state, action) => {
        state.loadingUserData = false;
        state.userData = action.payload;
      })
      .addCase(getUserById.rejected, (state, action) => {
        state.loadingUserData = false;
        state.errorUserData = action.payload;
      })
      .addCase(removeDriveSchoolFromUser.pending, (state) => {
        state.deleteLoading = true;
      })
      .addCase(removeDriveSchoolFromUser.fulfilled, (state) => {
        state.deleteLoading = false;
      })
      .addCase(removeDriveSchoolFromUser.rejected, (state) => {
        state.deleteLoading = false;
      });
  },
});

export const { setPage } = authSlice.actions;

export const selectActiveCategoryUser = (state) => state.auth.activeCategory;
export default authSlice.reducer;
